export default function (state, getters, rootState, rootGetters) {
    let col = getters.settings.col;
    let from = (state.page - 1) * col + 1;
    let to = (state.page * col) > state.items.length ? state.items.length : state.page * col;
    return from + ' - '+ to + ' из ' + state.items.length;
}